import React, { Component } from "react";

import FeatureCard from "../components/FeatureCard";

import "../css/style.css";
import "../css/WelcomePage.css";
// import { kebabCase } from "lodash";

export type HomeProps = { 

};

export default class Home extends Component<HomeProps> {
  
  render() {
    let issuerBaseUrl: string = process.env.REACT_APP_FRONTEND_BASE_URI ?? "";
    let verifierBaseUrl: string = process.env.REACT_APP_VP_FRONTEND_BASE_URI ?? "";
    return (
      <div className="home-container">
        <div className="home-hero">
          <div className="heroContainer home-hero1">
            <div className="home-container01">
              <h1 className="home-hero-heading heading1">
                Welcome to MySSI Use Cases
              </h1>
            </div>
          </div>
        </div>
        <div className="home-features">
          <div className="featuresContainer">
            <div className="home-features1">
              <div className="home-container02">
                <span className="overline">
                  <span>features</span>
                </span>
                <h2 className="home-features-heading heading2">
                  Explore Diverse Use Cases
                </h2>
                <span className="home-features-sub-heading bodyLarge">
                  <span>
                    <span>
                      <span>
                        Discover the possibilities of self-sovereign identity in
                        different industries
                      </span>
                    </span>
                  </span>
                </span>
              </div>
              <div className="home-container03">
                <FeatureCard
                  heading="Insurance Onboarding with Bank ID"
                  subHeading="Experience seamless insurance onboarding by utilizing your Bank ID."
                  issuer={{
                    text: "Online Banking",
                    link: issuerBaseUrl,
                  }}
                  verifier={{
                    text: "Insurance Company",
                    link: verifierBaseUrl + "/insurance",
                  }}
                />
                {/* <FeatureCard
                  heading="Fast Payment"
                  subHeading="New payment experience, allowing the users to easily and securely pay with their existing cards."
                  issuer={{
                    text: "Online Banking",
                    link: issuerBaseUrl,
                  }}
                  verifier={{
                    text: "Go to Hotel, MNO and Insurance use cases",
                    link:  "/",
                  }}
                /> */}
                <FeatureCard
                  heading="Hotel new check in experience"
                  subHeading="New hotel check in experience, using SSI credentials, like BankID / eID, Card VC and booking VC."
                  issuer={{
                    text: "Online Banking",
                    link: issuerBaseUrl,
                  }}
                  verifier={{
                    text: "Hotel Website",
                    link: verifierBaseUrl + "/hotel",
                  }}
                />
                <FeatureCard
                  heading="SIM Card Purchase via Bank ID and Card VC"
                  subHeading="Effortlessly purchase a prepaid SIM card using your Bank ID credentials to onboard and the Card VC to purchase."
                  issuer={{
                    text: "Online Banking",
                    link: issuerBaseUrl,
                  }}
                  verifier={{
                    text: "MNO Website",
                    link: verifierBaseUrl + "/telco",
                  }}
                />
                 {/* <FeatureCard
                  heading="Potential participation"
                  subHeading="Testing of the interoperability of the protocols"
                  issuer={{
                    text: "Issuer",
                    link: verifierBaseUrl + "/simple/issuer",
                  }}
                  verifier={{
                    text: "Verifier",
                    link: verifierBaseUrl + "/simple/verifier",
                  }}
                /> */}
                {/* <FeatureCard
                  heading="In-Person Agent Verification with SSI (TODO)"
                  subHeading="Verify agents seamlessly in-person through SSI-accredited centers."
                  issuer={{
                    text: "Learning Center (TODO)",
                    link: "/",
                  }}
                  verifier={{
                    text: "Peer2Peer verification (TODO)",
                    link: "/",
                  }}
                /> */}
                {/* <FeatureCard
                  heading="Authentic Club Membership Verification in Online Merchandise Shops (TODO)"
                  subHeading="Ensure genuine club membership for fans within online merchandise shops."
                  issuer={{
                    text: "Club Website (TODO)",
                    link: "/",
                  }}
                  verifier={{
                    text: "Partner Shop (TODO)",
                    link: "/",
                  }}
                /> */}
               
              </div>
            </div>
          </div>
        </div>
        <div className="home-banner">
          <div className="bannerContainer home-banner1">
            <h1 className="home-banner-heading heading2">
              Empower Yourself with Self-Sovereign Identity
            </h1>
            <span className="home-banner-sub-heading bodySmall">
              <span>
                <span>
                  <span>
                    Self-sovereign identity puts individuals in control of their
                    own digital identities, allowing for secure and private
                    interactions online. Discover how SSI can revolutionize
                    different industries and applications.
                  </span>
                </span>
              </span>
            </span>
          </div>
        </div>
        <div className="home-footer">
          <footer className="footerContainer home-footer1">
            <div className="home-container30">
              <span className="home-hero-heading heading2">Netcetera MySSI</span>
            </div>
            <div className="home-separator"></div>
            <div className="home-container31">
              <span className="bodySmall home-text88">
                © 2024 Netcetera, All Rights Reserved.
              </span>
            </div>
          </footer>
        </div>
      </div>
    );
  }
};